module.exports = __webpack_public_path__ + "static/media/wordmark-animation-white.588fb5ae.png";